<template>
  <div class="register-result">
    <div
      class="
        register-result__inner register-result__success
        bg-white
        flex
        column
        al-center
        pt-89
        pb-89
      "
      v-if="register_finished === 'success'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="90"
        height="90"
        viewBox="0 0 90 90"
      >
        <g
          id="Group_8608"
          data-name="Group 8608"
          transform="translate(-912 -398)"
        >
          <circle
            id="Ellipse_444"
            data-name="Ellipse 444"
            cx="45"
            cy="45"
            r="45"
            transform="translate(912 398)"
            fill="#28ad25"
          />
          <g id="fi-br-check" transform="translate(943 362.428)">
            <path
              id="Path_8819"
              data-name="Path 8819"
              d="M8.946,90.573a2.96,2.96,0,0,1-2.1-.869L.511,83.369a1.747,1.747,0,1,1,2.47-2.47l5.964,5.964L24.724,71.084a1.747,1.747,0,1,1,2.47,2.47L11.042,89.7a2.96,2.96,0,0,1-2.1.869Z"
              transform="translate(0 0)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>

      <h4 class="f-34 pangram-extrabold mt-34 mb-57">
        {{ $fn.tr("რეგისტრაცია წარმატებით დასრულდა") }}
      </h4>

      <a
        :href="_.get($store.state.main.indx, 'unicardAuthUrl')"
        class="
          register-result__button
          mb-21
          flex
          al-center
          f-white
          pangram-extrabold
        "
        >{{ $fn.tr("პირადი კაბინეტი") }}</a
      >
      <router-link class="register-result__success--link bold" :to="loyal_card_link.full_url">{{
        $fn.tr("მთავარი გვერდი")
      }}</router-link>
    </div>

    <div
      class="register-result__inner bg-white flex column al-center pt-89 pb-89"
      v-else
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="90"
        height="90"
        viewBox="0 0 90 90"
      >
        <g
          id="Group_9796"
          data-name="Group 9796"
          transform="translate(-912 -438)"
        >
          <circle
            id="Ellipse_444"
            data-name="Ellipse 444"
            cx="45"
            cy="45"
            r="45"
            transform="translate(912 438)"
            fill="#e50b09"
          />
          <g id="fi-br-plus" transform="translate(935.787 483.001) rotate(-45)">
            <path
              id="Path_8834"
              data-name="Path 8834"
              d="M28.125,13.125H16.875V1.875a1.875,1.875,0,0,0-3.75,0v11.25H1.875a1.875,1.875,0,0,0,0,3.75h11.25v11.25a1.875,1.875,0,0,0,3.75,0V16.875h11.25a1.875,1.875,0,0,0,0-3.75Z"
              fill="#fff"
            />
          </g>
        </g>
      </svg>

      <h4 class="f-34 pangram-extrabold mt-34 mb-55">
        {{ $fn.tr("დაფიქსირდა შეცდომა") }}
      </h4>

      <span
        class="register-result__back underline pangram-extrabold f-16 pointer"
        to="#"
        @click="back()"
        >{{ $fn.tr("სცადე თავიდან") }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    register_finished: String
  },

  methods: {
    back() {
      this.$parent.$emit("go-back");
    }
  },

  computed: {
    loyal_card_link() {
      return this.$store.state.main.indx.menus.filter(menu =>
        menu.configs.includes("loyal-card")
      )[0];
    }
  }
};
</script>

<style lang="scss">
.register-result {
  &__inner {
    width: 962px;
    margin: 0 auto;
  }
  &__button {
    background-color: #4d4d4f;
    height: 60px;
    padding-left: 60px;
    padding-right: 60px;
    transition: 0.4s;

    @include hover {
      background-color: black;
    }
  }
  &__back {
    color: #4d4d4f;
  }
  &__success {
    padding-left: 223px;
    padding-right: 223px;
    h4 {
      text-align: center;
      // width: 206px;
    }
    &--link {
      color: rgba(0, 0, 0, 0.3);
      transition: 0.4s;
      @include hover {
        color: black;
      }
    }
  }

  @media (max-width: 1125px) {
    &__inner {
      width: calc(100% - 90px);
    }
  }
  @media (max-width: 767px) {
    &__inner {
      width: calc(100% - 30px);
      padding-left: 30px;
      padding-right: 30px;
    }
    .f-34 {
      font-size: 21px;
      text-align: center;
    }
    &__button {
      text-align: center;
    }
  }
}
</style>
